// components/Form/Form.tsx (Componente contenedor)
import { FormHTMLAttributes, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import './formStyles.css';
import { SmartButton } from '../buttons/GralButton';
 
type FormProps = FormHTMLAttributes<HTMLFormElement> & {
  title?: string;
  width?: string;
  children: ReactNode;
  onSubmit?: any;
  actions?: ReactNode;
  cancelButtonNavigateTo?: string;
  confirmButtonLabel?: string;
  adaptToViewport?: boolean;
};
 
export const SmartForm = ({ 
	title, 
	children, 
	onSubmit, 
	actions, 
	cancelButtonNavigateTo,
	confirmButtonLabel,
	width,
	adaptToViewport,
	...props 
}: FormProps) => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
	e.preventDefault();
	if (onSubmit) {
	  onSubmit(e);
	}
  };
console.log("### params", cancelButtonNavigateTo)
  const navigate = useNavigate()
 
  const containerClassName = `form-container${adaptToViewport ? ' adapt-to-viewport' : ''}`
 
  return (
	<form {...props} 
		onSubmit={handleSubmit} 
		className={containerClassName}
		style={{width: width || '600px'}}
	>
	  {title && <h2 className="form-title">{title}</h2>}
	  <div className="form-content">{children}</div>
	  <div className="form-actions">
		{cancelButtonNavigateTo && <SmartButton 
		  type="button" 
		  onClick={() => {
			navigate(cancelButtonNavigateTo);
		  }}
		>
		  Cancelar
		</SmartButton>}
		{confirmButtonLabel && <SmartButton 
		  type="submit" 
		  onClick={() => {}} // onClick vacío para botones submit
		>
			{confirmButtonLabel}
		</SmartButton>}
		{actions}
	  </div>
	</form>
  );
};